const noResults = () => {
  const from_search = document.body.classList.contains('has-overlay-search');
  const grid_container = (from_search) ? document.querySelector('[data-overlay-search-results]') : document.querySelector('[data-product-tiles]');

  if (grid_container) {
    const grid = grid_container.querySelector('.grid');
    if (grid) {
      grid.innerHTML = '<div class="products__no-results column-xs-12">Sorry, no products matched your selection</div>';
    }
  }

  const pagination_count = grid_container.querySelector('.products__pagination-count');
  if (pagination_count) {
    pagination_count.classList.add('hidden');
  }

  const pagination = grid_container.querySelector('[data-pagination]');
  if (pagination) {
    pagination.classList.add('hidden');
  }

  const mobileFilterNav = document.querySelector('[data-collection-grid-container] [data-show-mobile-filter-nav]');
  if (mobileFilterNav) {
    mobileFilterNav.classList.remove('active');
  }

  document.querySelectorAll('[data-total-filtered-items]').forEach(el => {
    el.textContent = '0 items';
  });
};

const removeNoResults = () => {
  const from_search = document.body.classList.contains('has-overlay-search');

  const gridContainer = (from_search) ? document.querySelector('[data-overlay-search-grid-container] .grid') : document.querySelector('[data-collection-grid-container] .grid');

  if (!gridContainer) {
    return;
  }

  const no_results_div = gridContainer.querySelector('.products__no-results');
  if (!no_results_div) {
    return;
  }

  no_results_div.remove();
};

export {
  noResults,
  removeNoResults,
};
